import { render, staticRenderFns } from "./ChatwootWidget.vue?vue&type=template&id=57c7535a"
import script from "./ChatwootWidget.vue?vue&type=script&lang=js"
export * from "./ChatwootWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatwootWidget.vue?vue&type=style&index=0&id=57c7535a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports